import { Component, OnInit, Injector } from "@angular/core";
import { BorderObject } from "../classes/border-object";
import { PredictJsonObject } from "../classes/predict-json-object";
import { PredictionResultDto, PredictResultServiceProxy } from "@shared/service-proxies/service-proxies";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Component({
	selector: "kt-selectable-border",
	templateUrl: "./selectable-border.component.html",
	styleUrls: ["./selectable-border.component.scss"],
})
export class SelectableBorderComponent implements OnInit {
	id: string | undefined;
	nesneAlgilamaSonucuObject: PredictionResultDto;
	predictJsonObject = new BehaviorSubject<PredictJsonObject>(null);

	borders = new BehaviorSubject<BorderObject[]>(null);
	imageUrl = new BehaviorSubject<string>(null);
	labelSummaries = new BehaviorSubject<{ [key: string]: string }>(null);

	imageWidth: number;
	imageHeight: number;

	labelBackgroundColor: boolean = false;
	isChecked: boolean = false;
  	isVisible: boolean = true;
  	zIndexValue: number;
	labelString: string;

	//-----------------------------
	index: number = 0;
	productCount: number;
	borderArray: BorderObject[];

	/**
	 * Form gonderilirken bu deger true degerini alir.
	 */
	isFormSending = new BehaviorSubject<boolean>(false);

	constructor(private _route: ActivatedRoute, 
		private _predictResultService: PredictResultServiceProxy) {
		//URL üzerinden ilgili kayıdın GUID id bilgisi girişi alınır ve yerel değişkene inject edilir.
		this._route.paramMap.subscribe((params) => {
			this.id = params.get("id");
			console.log("id", this.id);
		});
	}

	ngOnInit() {
		//Sayfa yüklenirken API bağlantısı üzerinden NesneAlgilamaSonuc entity üzerindeki ilgili kayıdın bilgilerini çeker ve
		//yerel değişkenlere aktarır. Böylelikle sayfada görsel üzerindeki borderlamaları, checkboxları, labelları gibi diğer işlemlerin
		//yürütülmesi yerel değişkenler üzerinden yapılır.
		//Sayfa yüklenirken sunucu tarafının beklenilmesi için BehaviorSubject<> kullanıldı.
		try {
			this._predictResultService.getImagePredictionResult(this.id).subscribe((result: PredictionResultDto) => {
				this.nesneAlgilamaSonucuObject = result;
				console.log(result);
				let parseJsonObject = JSON.parse(result.predictJson); //JSON.parse(this.nesneAlgilamaSonucuObject.predictJson);

				//BehaviorSubject
				this.predictJsonObject.next(parseJsonObject);
				this.borders.next(parseJsonObject.predict_results); // = this.predictJsonObject.value.predict_results;
				this.imageUrl.next(parseJsonObject.request_image_url); // this.imageUrl.next(parseJsonObject.result_image_url);
				this.labelSummaries.next(parseJsonObject.label_summary);
				console.log("imageUrl:", this.imageUrl);

				this.filterLabelSummaries(this.labelSummaries);
				this.updateProductCount();
			});
		} catch (error) {
			throw new alert(this.id + "ilgili kayıt yüklenirken bir sorun oluştu.");
		}
	}

	//Borderların hemen üzerine konumlandırdığımız labelların renklerini borderların isSelected durumuna göre düzenler. (kırmızı | yeşil gibi..)
	setLabelBackgroundColor(isSelected: boolean) {
		return {
			backgroundColor: isSelected ? "#19CE0B" : "#CE0B0B",
		};
	}

	//Borderların üzerine tıklandığında seçim durumunun düzenlenmesini sağlıyor. ve tekrardan ilgili border'ın style fonksiyonu ile güncelleniyor
	toggleSelection(border: BorderObject) {
		border.isSelected = !border.isSelected;
		this.getBorderStyle(border);
	}

	//Bir checkbox'a bağlandı.
	//Görsel üzerine çizdirilen tüm borderları bir kerede isSelected = true yapar daha sonra rengini düzenlemesi için diğer methodu tetikler.
	setAllSelected(borders: BorderObject[]) {
		if (this.isChecked) {
			borders.forEach((element) => {
				element.isSelected = true;
				this.getBorderStyle(element);
			});
		} else {
			borders.forEach((element) => {
				element.isSelected = false;
				this.getBorderStyle(element);
			});
		}
	}

	//Görsel üzerinde çizilecek borderların özelliklerini ayarlar
	getBorderStyle(border: BorderObject) {
		return {
			title: border.tagname,
			top: border.bounding_box.left * this.imageHeight + "px",
			left: border.bounding_box.top * this.imageWidth + "px",
			width: border.bounding_box.width * this.imageWidth - border.bounding_box.top * this.imageWidth + "px",
			height: border.bounding_box.height * this.imageHeight - border.bounding_box.left * this.imageHeight + "px",
			// borderColor: border.isSelected ? '#19CE0B': '#CE0B0B'
		};
	}

	//img (load) evente bağlıyoruz. Görselin en ve boyunu yerel değişkene alır.
	getImageSize(image: HTMLImageElement) {
		this.imageWidth = image.width;
		this.imageHeight = image.height;
	}

	//Bu method ile görsel üzerindeki borderları kullanıcı tarafından onaylanan nihai halini CRM -> entity üzerinde
	//ilgili kayıdın predictJSON alanını günceller.
	sendApprovedBorder() {
		// this.predictJsonObject.value.predict_results = this.borders;

		//let pp = this.predictJsonObject.getValue().predict_results = this.borders

		// let jsPredictJsonObject = JSON.stringify(this.predictJsonObject.value);

		this.isFormSending.next(true);

		this.nesneAlgilamaSonucuObject.predictJson = JSON.stringify(this.predictJsonObject.value);

		this._predictResultService.updateImagePredictionResult(this.nesneAlgilamaSonucuObject).subscribe(
			(response) => {
				alert("İşlem tamamlandi");
			},
			(error) => {
				alert("Form gönderilirken bir sorun ile karşılaşıldı!");
			},
			() => {
				this.isFormSending.next(false);
			}
		);
	}

	//LabelSummary başlığı ile borderlar üzerindeki tagname'e göre kıyaslama yapar. Böylelikle ilgili border için ilgili labelsummary ayırt edilir.
	//LabelSummary ve tagname arasında aynı değere sahip olan borderlar için true değeri döner.
	//borderlar ile checkboxları eşleştirmede kullanıyoruz.
	checkSummaryAndTagname(summary: string, tagname: string): boolean | any {
		if (summary === tagname) {
			return true;
		} else {
			return false;
		}
	}

	//Borders içerisinde birde fazla ürün için border listesi olursa array içerisindeki index sırasına göre
	//borderların farklı renklere sahip olması için CSS class isimlerini html tarafı için return eder.
	getBorderColorClass(index: number) {
		if (index === 0) {
			return "border-success";
		} else if (index === 1) {
			return "border-success1";
		} else if (index === 2) {
			return "border-success2";
		} else if (index === 3) {
			return "border-success3";
		} else if (index === 4) {
			return "border-success4";
		} else if (index === 5) {
			return "border-success5";
		} else if (index === 6) {
			return "border-success6";
		} else if (index === 6) {
			return "border-success6";
		} else if (index === 7) {
			return "border-success7";
		} else if (index === 8) {
			return "border-success8";
		} else if (index === 9) {
			return "border-success9";
		} else if (index === 10) {
			return "border-success10";
		} else {
			return "border-success-default";
		}
	}

	//LabelSummaries içerisinde birde fazla ürün için label listesi olursa array içerisindeki index sırasına göre
	//labelların farklı renklerde arkaplana sahip olması için CSS class isimlerini html tarafı için return eder.
	getLabelColorClass(index: number) {
		if (index === 0) {
			return "label-success";
		} else if (index === 1) {
			return "label-success1";
		} else if (index === 2) {
			return "label-success2";
		} else if (index === 3) {
			return "label-success3";
		} else if (index === 4) {
			return "label-success4";
		} else if (index === 5) {
			return "label-success5";
		} else if (index === 6) {
			return "label-success6";
		} else if (index === 7) {
			return "label-success7";
		} else if (index === 8) {
			return "label-success8";
		} else if (index === 9) {
			return "label-success9";
		} else if (index === 10) {
			return "label-success10";
		} else {
			return "label-success-default";
		}
	}

	updateProductCount() {
		this.borderArray = this.borders.getValue();
		this.productCount = this.borderArray.length;
	}

	//LabelSummaries içerisindeki = 0 olan değerleri kalabalık yapmaması için çıkarır
	filterLabelSummaries(subject: BehaviorSubject<{ [key: string]: string }>) {
		const currentValue = subject.getValue();

		if (currentValue) {
			const filteredValue = Object.keys(currentValue)
				.filter((key) => currentValue[key] != "0")
				.reduce((acc, key) => {
					acc[key] = currentValue[key];
					console.log("acc:", acc);
					return acc;
				}, {});

			subject.next(filteredValue);
		}
	}

	calcPercentage(value: number): string {
		if (this.productCount === 0) {
			return "0.00";
		}

		const percentage = (value / this.productCount) * 100;
		return percentage.toFixed(2);
	}

  changeBorderVisible(){
    this.isVisible = !this.isVisible;    
  }
}
